import {
  getAllCatalogProducts,
  getAllCatalogCategories,
  getAllCatalogSubcategories,
  registerCatalogFallback,
} from '../utils/customProducts';

const IMG = (id) =>
  `https://static.prod-images.emergentagent.com/jobs/d339d82d-0dd2-4f32-aba3-f3f38b026a7c/images/${id}.jpeg`;

export const HERO_IMAGE = IMG('f479a870473a71aad0efdc9db1ce1628e51168f4ed6e832ef1b4e212b843ed48');

export const STORE = {
  name: 'Huddersfield Tecidos',
  address: 'Praça Osório, 15 - Centro - Curitiba/PR',
  phone: '(41) 3224-4723',
  whatsapp: '(41) 3224-4723',
  whatsappDigits: '554132244723',
};

export const CATEGORIES = [
  {
    slug: 'alfaiataria',
    name: 'Alfaiataria',
    tagline: 'Sofisticação em cada detalhe',
    image: IMG('bb03504d5ec992e2d73f784f8346b8c6da4ea5616764b986139f988eaae0ccc7'),
    description:
      'Tecidos estruturados e elegantes para ternos, blazers, calças sociais e peças sob medida.',
  },
  {
    slug: 'linhos',
    name: 'Linhos',
    tagline: 'Leveza e versatilidade',
    image: IMG('050f59cd1f0aac720dfc5292c59184ee030eb2783b46834f883c0b28f2e5d732'),
    description:
      'Linhos puros e mistos, do rústico ao refinado, perfeitos para peças leves e atemporais.',
  },
  {
    slug: 'malhas',
    name: 'Malhas',
    tagline: 'Conforto em movimento',
    image: IMG('d32a82c3cdc7000d5223680a98ad00382ed79b80be21657936867d19f34a4785'),
    description: 'Malhas caneladas, piquet, moletinhos e ribanas para o conforto do dia a dia.',
  },
  {
    slug: 'estampados',
    name: 'Estampados',
    tagline: 'Cores que inspiram',
    image: IMG('01969036da8e5c8a524ae116475707b35a7227dd1b9a33be7b2767b847350121'),
    description: 'Florais, poás, xadrezes e folhagens em tricolines, crepes e viscoses.',
  },
  {
    slug: 'festa',
    name: 'Festa',
    tagline: 'Para momentos especiais',
    image: IMG('f12c1f5b4a8f97bc7aa3b7022e4711c73480d4a3606b1d13f769e2abe49b4ed4'),
    description: 'Crepes, cetins, tules e veludos para vestidos de festa e ocasiões especiais.',
  },
  {
    slug: 'decoracao',
    name: 'Decoração',
    tagline: 'Beleza para o seu espaço',
    image: IMG('b2681b8a546bef288bacae68ae7d15f3844b2c8104aa04b448c1e43c0613439f'),
    description: 'Tecidos encorpados para cortinas, almofadas, estofados e projetos de decoração.',
  },
];

const V = (id, name, imageId, description = '') => ({
  id,
  name,
  image: IMG(imageId),
  description,
  status: 'DISPONIVEL',
  statusHistory: [],
});

export const PRODUCTS = [
  {
    slug: 'la-fria',
    name: 'Lã Fria',
    categorySlug: 'alfaiataria',
    description:
      'Lã fria de alfaiataria com caimento impecável, toque seco e elegante. O tecido clássico para ternos e costumes sob medida.',
    composition: 'Lã fria e poliéster',
    width: '1,50 m',
    colorTags: ['azul', 'cinza', 'xadrez'],
    usageTags: ['alfaiataria', 'ternos', 'blazers', 'calças sociais'],
    keywords: ['tecido para terno', 'tecido para blazer', 'lã fria'],
    featured: true,
    variants: [
      V('azul-marinho', 'Azul-marinho', 'bb03504d5ec992e2d73f784f8346b8c6da4ea5616764b986139f988eaae0ccc7', 'Liso, profundo e versátil.'),
      V('cinza-liso', 'Cinza liso', 'c0b33780f9b94ab0a0684bbf157e2a594cfa717a918682cecfa5b75dcc7f571b', 'Cinza médio liso, executivo.'),
      V('espinha-de-peixe-cinza', 'Espinha de peixe cinza', 'c48620a45f550027db3d13ac0ae50e0b8db970f6da1e3d67307295c795226ac2', 'Padrão espinha de peixe tecido.'),
      V('xadrez-azul', 'Xadrez azul', 'b3f5d8d909bbd94bcb77d291ebd393c3ddb65d0afc0eb7a977b3e196970dff16', 'Xadrez em tons de azul.'),
    ],
  },
  {
    slug: 'alfaiataria-risca-de-giz',
    name: 'Alfaiataria Risca de Giz',
    categorySlug: 'alfaiataria',
    description: 'Clássico risca de giz, elegante para costumes e ternos executivos.',
    composition: 'Poliéster, viscose e elastano',
    width: '1,50 m',
    colorTags: ['cinza', 'listrado'],
    usageTags: ['alfaiataria', 'ternos', 'calças sociais'],
    keywords: ['tecido para terno', 'risca de giz'],
    variants: [V('cinza', 'Cinza', '14d5065bcc6a005a1e248fdc0db52d6cb97b3721624701ca9e194b7fe7717764')],
  },
  {
    slug: 'tropical-fresco',
    name: 'Tropical Fresco',
    categorySlug: 'alfaiataria',
    description: 'Tecido frio e leve, ideal para ternos e calças de alfaiataria em climas quentes.',
    composition: 'Poliéster e viscose',
    width: '1,50 m',
    colorTags: ['preto'],
    usageTags: ['alfaiataria', 'ternos', 'calças sociais', 'verão'],
    keywords: ['tecido para terno', 'tecido leve'],
    variants: [V('preto', 'Preto', 'b4c9f8111852daf65355c8495af4ea60b9de58b574d039b3bdaa04f329d26066')],
  },
  {
    slug: 'xadrez-principe-de-gales',
    name: 'Alfaiataria Xadrez Príncipe de Gales',
    categorySlug: 'alfaiataria',
    description: 'O clássico xadrez da alfaiataria britânica, para blazers e calças com personalidade.',
    composition: 'Poliéster e viscose',
    width: '1,48 m',
    colorTags: ['cinza', 'azul', 'xadrez'],
    usageTags: ['alfaiataria', 'blazers', 'calças sociais'],
    keywords: ['tecido para blazer', 'xadrez'],
    variants: [V('cinza-azul', 'Cinza e azul', '463592d86711f8ad8b10a98d3fa646edabb2d65ad000a2d172e189c27382d70b')],
  },
  {
    slug: 'sarja-alfaiataria',
    name: 'Sarja Alfaiataria',
    categorySlug: 'alfaiataria',
    description: 'Sarja encorpada de toque refinado, versátil para calças, bermudas e paletós.',
    composition: 'Algodão com elastano',
    width: '1,50 m',
    colorTags: ['bege'],
    usageTags: ['alfaiataria', 'calças', 'casual'],
    keywords: ['tecido para calça'],
    variants: [V('bege', 'Bege', '2aa979d1878a4660f0c330ba218a69aa1a18405e4bfa68ec0312d26b2883fbe8')],
  },
  {
    slug: 'oxford-algodao',
    name: 'Oxford Algodão',
    categorySlug: 'alfaiataria',
    description: 'Oxford de algodão clássico para camisas sociais e casuais.',
    composition: '100% algodão',
    width: '1,50 m',
    colorTags: ['azul'],
    usageTags: ['camisas', 'casual'],
    keywords: ['tecido para camisa'],
    variants: [V('azul-claro', 'Azul claro', '32d61c197edf677e90c51dd3077e5cb5e88f245d152181dd186470fe2cdab5c8')],
  },
  {
    slug: 'linho-misto',
    name: 'Linho Misto',
    categorySlug: 'linhos',
    description: 'Mistura de linho e viscose com caimento leve e textura natural sofisticada.',
    composition: 'Linho e viscose',
    width: '1,40 m',
    colorTags: ['bege'],
    usageTags: ['camisas', 'vestidos', 'verão'],
    keywords: ['tecido leve para verão', 'tecido para vestido'],
    featured: true,
    variants: [V('natural', 'Natural', '050f59cd1f0aac720dfc5292c59184ee030eb2783b46834f883c0b28f2e5d732')],
  },
  {
    slug: 'linho-roma',
    name: 'Linho Roma',
    categorySlug: 'linhos',
    description: 'Linho leve de trama fina, fresco e elegante para peças de verão.',
    composition: '100% linho',
    width: '1,45 m',
    colorTags: ['bege'],
    usageTags: ['camisas', 'vestidos', 'verão'],
    keywords: ['tecido leve para verão', 'linho bege'],
    variants: [V('bege-claro', 'Bege claro', '143f17c7efb1d40f45f808df3f61a44a3da4da5f5d095092b07a57342bd02c41')],
  },
  {
    slug: 'linho-puro',
    name: 'Linho Puro',
    categorySlug: 'linhos',
    description: 'Linho puro, fresco e atemporal, perfeito para camisas e vestidos.',
    composition: '100% linho',
    width: '1,45 m',
    colorTags: ['branco'],
    usageTags: ['camisas', 'vestidos', 'verão'],
    keywords: ['tecido leve para verão', 'linho branco'],
    variants: [V('branco', 'Branco', 'ab92ecef4740ca1d749da18350449bda786f8fd10f391013418f4bb69c767b0d')],
  },
  {
    slug: 'linho-lavado',
    name: 'Linho Lavado',
    categorySlug: 'linhos',
    description: 'Linho lavado em tom índigo, com visual descontraído e toque macio.',
    composition: '100% linho',
    width: '1,42 m',
    colorTags: ['azul'],
    usageTags: ['camisas', 'calças', 'casual', 'verão'],
    keywords: ['tecido leve para verão'],
    variants: [V('azul-jeans', 'Azul jeans', '59c3cc3d165d38f46a8f36496885f8f0f2476cbf1d5647bf2d35c732ddcd27c0')],
  },
  {
    slug: 'linho-rustico',
    name: 'Linho Rústico',
    categorySlug: 'linhos',
    description: 'Linho de trama rústica, charmoso para peças artesanais e decoração.',
    composition: '100% linho',
    width: '1,50 m',
    colorTags: ['bege', 'natural'],
    usageTags: ['artesanato', 'decoração', 'casual'],
    keywords: ['linho rústico', 'tecido para artesanato'],
    variants: [V('cru', 'Cru', '4088d154164450d92fd263fa904d07424192a8413961a5a6430ed3a286812c00')],
  },
  {
    slug: 'malha-canelada',
    name: 'Malha Canelada',
    categorySlug: 'malhas',
    description: 'Malha canelada com ótima elasticidade, ideal para blusas e vestidos justos.',
    composition: 'Viscose com elastano',
    width: '1,60 m',
    colorTags: ['verde'],
    usageTags: ['blusas', 'vestidos', 'casual'],
    keywords: ['malha verde', 'tecido para blusa'],
    featured: true,
    variants: [V('verde', 'Verde', 'd32a82c3cdc7000d5223680a98ad00382ed79b80be21657936867d19f34a4785')],
  },
  {
    slug: 'malha-piquet',
    name: 'Malha Piquet',
    categorySlug: 'malhas',
    description: 'Piquet clássico de textura colméia, perfeito para polos e peças esportivas finas.',
    composition: 'Algodão penteada',
    width: '1,75 m',
    colorTags: ['branco'],
    usageTags: ['polos', 'camisas', 'casual'],
    keywords: ['tecido para polo'],
    variants: [V('branca', 'Branca', 'cc636576bbedfc6fc631a1b2ac7889b5b2ed18578aac7bf4b09ad473a8070fa7')],
  },
  {
    slug: 'moletinho-felpado',
    name: 'Moletinho Felpado',
    categorySlug: 'malhas',
    description: 'Moletinho com felpa interna macia, aconchegante para moletons e joggers.',
    composition: 'Algodão e poliéster',
    width: '1,80 m',
    colorTags: ['cinza'],
    usageTags: ['moletons', 'casual', 'inverno'],
    keywords: ['tecido para moletom'],
    variants: [V('mescla', 'Mescla', 'c46c9bee621c185a140b30b7a0815d27855839b168344e60af3f80b69b1fb1a1')],
  },
  {
    slug: 'ribana',
    name: 'Ribana',
    categorySlug: 'malhas',
    description: 'Ribana de fio penteado em tom terroso, excelente para croppeds e golas.',
    composition: 'Algodão com elastano',
    width: '1,20 m',
    colorTags: ['terracota'],
    usageTags: ['blusas', 'casual'],
    keywords: ['ribana', 'tecido para blusa'],
    variants: [V('terracota', 'Terracota', '5972084612c2002c48763e0ab6ef158975e925eff5236609cfbd1a9ca43ec077')],
  },
  {
    slug: 'tricoline-estampada',
    name: 'Tricoline Estampada',
    categorySlug: 'estampados',
    description:
      'Tricoline 100% algodão de toque macio, em estampas variadas. Ótima para artesanato, moda e peças infantis.',
    composition: '100% algodão',
    width: '1,50 m',
    colorTags: ['rosa', 'azul', 'vermelho', 'estampado', 'floral', 'xadrez', 'poá'],
    usageTags: ['artesanato', 'vestidos', 'infantil'],
    keywords: ['tricoline floral', 'tecido para artesanato', 'tricoline'],
    featured: true,
    variants: [
      V('floral-rosa', 'Floral rosa', '01969036da8e5c8a524ae116475707b35a7227dd1b9a33be7b2767b847350121', 'Floral romântico em tons rosé.'),
      V('floral-azul', 'Floral azul', 'e380e75486d83e8a87f9373630a05cca0a45b68dbc584741a24bc262a6b3522d', 'Floral delicado em azul.'),
      V('xadrez-vermelho', 'Xadrez vermelho', 'ea4c8c52c520fe94b51cbd302b814ff14fb9e2d9e3e96588e627dde7880128d8', 'Xadrez vichy vermelho clássico.'),
      V('poa-azul', 'Poá azul', '696b8e3edc19d763a0146faa90f23e16bd5c6e032854b2b51b3cd27a894f59c8', 'Poá branco sobre azul claro.'),
    ],
  },
  {
    slug: 'viscose-poa',
    name: 'Viscose Estampada Poá',
    categorySlug: 'estampados',
    description: 'Viscose fluida com estampa poá clássica, caimento leve para vestidos e blusas.',
    composition: '100% viscose',
    width: '1,40 m',
    colorTags: ['preto', 'estampado', 'poá'],
    usageTags: ['vestidos', 'blusas', 'verão'],
    keywords: ['tecido para vestido', 'poá'],
    variants: [V('preto', 'Preto', '962506c92f3697eee3e69644de8cdf20d15fe5c9ca6673a0ff485e73277feca3')],
  },
  {
    slug: 'crepe-folhagens',
    name: 'Crepe Estampado Folhagens',
    categorySlug: 'estampados',
    description: 'Crepe leve com estampa botânica de folhagens, fresco e elegante.',
    composition: 'Viscose',
    width: '1,45 m',
    colorTags: ['verde', 'estampado', 'floral'],
    usageTags: ['vestidos', 'blusas', 'verão'],
    keywords: ['tecido leve para verão', 'tecido para vestido'],
    variants: [V('verde', 'Verde', '5d3bd0562f357da1ccd9cde86c8008c9040089670846b4f5034435c917cb38f3')],
  },
  {
    slug: 'crepe-dior',
    name: 'Crepe Dior',
    categorySlug: 'festa',
    description: 'Crepe com caimento fluido e textura refinada, perfeito para vestidos de festa.',
    composition: 'Poliéster e elastano',
    width: '1,50 m',
    colorTags: ['rosa'],
    usageTags: ['vestidos', 'festa'],
    keywords: ['tecido para vestido', 'tecido para festa', 'crepe rosa'],
    featured: true,
    variants: [V('rosa-antigo', 'Rosa antigo', 'f12c1f5b4a8f97bc7aa3b7022e4711c73480d4a3606b1d13f769e2abe49b4ed4')],
  },
  {
    slug: 'cetim-de-seda',
    name: 'Cetim de Seda',
    categorySlug: 'festa',
    description: 'Cetim de brilho suave e toque sedoso, luxo para vestidos de noiva e madrinhas.',
    composition: 'Seda e viscose',
    width: '1,40 m',
    colorTags: ['champanhe', 'bege'],
    usageTags: ['vestidos', 'festa', 'noivas'],
    keywords: ['tecido para festa', 'cetim'],
    variants: [V('champanhe', 'Champanhe', 'aa380dea95d17b032d71e5cfff9c552faed70d3454aa18c213fe3cd3c6c90cc7')],
  },
  {
    slug: 'tule-bordado',
    name: 'Tule Bordado',
    categorySlug: 'festa',
    description: 'Tule bordado com aplicações delicadas, para vestidos de gala e sobreposições.',
    composition: 'Poliamida bordada',
    width: '1,30 m',
    colorTags: ['azul'],
    usageTags: ['vestidos', 'festa', 'noivas'],
    keywords: ['tecido para festa', 'tule bordado'],
    variants: [V('azul-noite', 'Azul noite', '8f4c17cca6bda0a6e08d9e34cecb145f9561f7ac35c42308167098f1cefc9402')],
  },
  {
    slug: 'veludo-royal',
    name: 'Veludo Royal',
    categorySlug: 'festa',
    description: 'Veludo intenso de toque aveludado e brilho profundo, presença garantida.',
    composition: 'Poliéster e elastano',
    width: '1,50 m',
    colorTags: ['azul', 'veludo'],
    usageTags: ['vestidos', 'festa', 'inverno'],
    keywords: ['veludo azul', 'tecido para festa'],
    variants: [V('azul-royal', 'Azul royal', '901e127be15877a9cea5c26fb1c338673754a3fca2878e08eb75c448067e6059')],
  },
  {
    slug: 'crepe-moss',
    name: 'Crepe Moss',
    categorySlug: 'festa',
    description: 'Crepe encorpado de textura elegante, curinga para vestidos e conjuntos sociais.',
    composition: 'Poliéster e elastano',
    width: '1,50 m',
    colorTags: ['preto'],
    usageTags: ['vestidos', 'festa', 'calças sociais'],
    keywords: ['crepe preto', 'tecido para vestido'],
    variants: [V('preto', 'Preto', '3e658339f053591e519208fa148e3e3d87735a2ae4e7c786a21362e4c95c18a9')],
  },
  {
    slug: 'decoracao-linho-rustico',
    name: 'Linho Rústico para Decoração',
    categorySlug: 'decoracao',
    description: 'Trama encorpada de linho rústico, ideal para cortinas, almofadas e estofados leves.',
    composition: 'Linho e algodão',
    width: '1,50 m',
    colorTags: ['bege', 'natural'],
    usageTags: ['decoração', 'cortinas', 'almofadas'],
    keywords: ['tecido para decoração', 'tecido para cortina'],
    featured: true,
    variants: [V('natural', 'Natural', 'b2681b8a546bef288bacae68ae7d15f3844b2c8104aa04b448c1e43c0613439f')],
  },
  {
    slug: 'jacquard-geometrico',
    name: 'Jacquard Geométrico',
    categorySlug: 'decoracao',
    description: 'Jacquard de desenho geométrico tecido, sofisticação para almofadas e estofados.',
    composition: 'Algodão e poliéster',
    width: '1,40 m',
    colorTags: ['azul', 'estampado'],
    usageTags: ['decoração', 'almofadas', 'estofados'],
    keywords: ['tecido para decoração', 'jacquard'],
    variants: [V('azul-cru', 'Azul e cru', 'b65304308848b7b17d687b84bb72a6279cfa862061cc13da065f09cab9d3be84')],
  },
  {
    slug: 'veludo-cotele',
    name: 'Veludo Cotelê',
    categorySlug: 'decoracao',
    description: 'Cotelê aveludado em tom mostarda, aconchego e estilo retrô para o décor.',
    composition: 'Algodão',
    width: '1,45 m',
    colorTags: ['mostarda', 'veludo'],
    usageTags: ['decoração', 'estofados', 'casual'],
    keywords: ['veludo cotelê', 'tecido para decoração'],
    variants: [V('mostarda', 'Mostarda', 'd3e007cf2d2763215ee5de3a1c02bd7599651b7da92204a4c996d416e7310bf3')],
  },
  {
    slug: 'sarja-impermeavel',
    name: 'Sarja Impermeável',
    categorySlug: 'decoracao',
    description: 'Sarja resinada com estampa botânica, prática para toalhas, aventais e áreas externas.',
    composition: 'Algodão resinado',
    width: '1,50 m',
    colorTags: ['verde', 'estampado', 'floral'],
    usageTags: ['decoração', 'artesanato'],
    keywords: ['tecido impermeável', 'tecido para decoração'],
    variants: [V('botanica', 'Estampa botânica', 'eb5e17c214b27ed2ac472e3cb6175306435fa0d6fcc775cc0d173f2dba39866d')],
  },
];

export const normalize = (s) =>
  (s || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

export function searchProducts(query) {
  const tokens = normalize(query).split(/\s+/).filter(Boolean);
  if (!tokens.length) return [];
  return getAllProducts().filter((p) => {
    const cat = getAllCategories().find((c) => c.slug === p.categorySlug);
    const variantNames = (p.variants || []).map((v) => v.name).join(' ');
    const hay = normalize(
      [p.name, variantNames, cat?.name, p.description, ...(p.colorTags || []), ...(p.usageTags || []), ...(p.keywords || [])].join(' ')
    );
    return tokens.every((t) => hay.includes(t));
  });
}

export function searchProductsDetailed(query) {
  const tokens = normalize(query).split(/\s+/).filter(Boolean);
  if (!tokens.length) return [];
  return searchProducts(query).map((p) => ({
    product: p,
    variantMatch: p.variants.filter((v) => tokens.every((t) => normalize(v.name).includes(t))),
  }));
}

// Camada consolidada: o servidor (MongoDB) é a fonte única do catálogo — catálogo
// inicial semeado uma vez + tudo o que o painel cadastrar/editar/remover.
// Todo o sistema (busca, categorias, produto, disponibilidade, revisão) lê daqui.
export const getAllProducts = () => getAllCatalogProducts();

export const getProduct = (slug) => getAllProducts().find((p) => p.slug === slug);
export const getVariant = (product, variantId) =>
  product?.variants.find((v) => v.id === variantId) || product?.variants[0];

// Categorias e subcategorias vêm do servidor; todas são registros normais e editáveis.
export const getAllCategories = () => getAllCatalogCategories();

export const getCategory = (slug) => getAllCategories().find((c) => c.slug === slug);

// Subcategorias de uma categoria (vazio quando a categoria não tem nenhuma).
export const getSubcategories = (categorySlug) => getAllCatalogSubcategories().filter((s) => s.categorySlug === categorySlug);
export const getSubcategory = (slug) => getAllCatalogSubcategories().find((s) => s.slug === slug);

// Reserva estática (somente se a API estiver indisponível no carregamento inicial).
registerCatalogFallback(() => ({ products: PRODUCTS, categories: CATEGORIES, subcategories: [] }));

export function formatMeters(m) {
  return `${String(m).replace('.', ',')} m`;
}

export function maskPhoneBR(value) {
  const d = (value || '').replace(/\D/g, '').slice(0, 11);
  if (d.length <= 2) return d.length ? `(${d}` : '';
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

export const formatBRL = (v) =>
  v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
